import React, { useState } from 'react'
import img from '../assets/product-img.png'
import { InboxIcon, ShareIcon, UserCircleIcon } from '@heroicons/react/outline';
import { useSelector } from 'react-redux';
import { FormatAmount, formatDate } from '../Controllers/FormatAmount';
import Popup from '../Controllers/Popup';
import SocialShare from '../Controllers/SocialShare';
import { fileDownloader } from '../Controllers/fileDownload';
import { ChevronDown } from 'react-bootstrap-icons';
import RefundProduct from '../Controllers/RefundProduct';
import NO_PHOTO from '../assets/nophoto.png'
const ViewOrder = ({ orderData }) => {
    const { staffInfo } = useSelector((state) => state?.authReducer)
    const [openShare, setOpenShare] = useState(false)
    const [openRefund, setOpenRefund] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState([])
    const [productInfo, setProductInfo] = useState([])
    const calculateTotalPrice = (products) =>
        products.reduce((total, product) => total + product?.selling_price * product?.quantity, 0);
    const downloadInvoice = () => {
        fileDownloader(orderData?.order?.invoice, orderData?.order?.order_id);
    }
    const handleClosePopup = () => {
        setOpenShare(false);
    }
    const handleCloseRefundPopup = () => {
        setOpenRefund(false);
        setProductInfo([]);
        setSelectedProduct([]);
    }
    const isRetunable = orderData?.order?.products?.filter(item => item?.product_return_policy === 'returnable' && new Date(item?.return_valid_till_date) >= new Date() && !item?.is_return)
    return (
        <>
            {
                orderData?.isShow === true ?
                    <div className='p-4 flex flex-col gap-4'>
                        <div className='flex gap-4 flex-wrap items-center justify-between'>
                            <div>
                                <span className='flex items-center gap-1 text-lg font-semibold'> <UserCircleIcon className='w-5 h-5' />{orderData?.order?.user?.name || '-'}</span>
                                <div className='flex flex-wrap items-center gap-6 info-text text-sm'>
                                    <span>{formatDate(orderData?.order?.order_date, staffInfo?.client)}</span>
                                    <span>{`#${orderData?.order?.order_id}`}</span>
                                </div>
                            </div>
                            <span className={`status-bedge ${orderData?.order?.status === 'pending' ? 'text-[#FF8514] bg-[#FFFAF5]' : 'text-[#238823] bg-[#F4FDF5]'} `}>
                                {orderData?.order?.status === 'pending' ? 'Pending' : 'Completed'}
                            </span>
                        </div>
                        <span className='text-[16px] block font-semibold'>Products Information</span>
                        <details
                            open
                            className='bg-white group table-text shadow !mb-2 space-y-4 rounded-[6px] !p-[14px] sm:p-[25px]'
                        >
                            <summary className='flex items-center justify-center cursor-pointer'>
                                <span className='flex-1 text-[16px] block font-medium'>Products Information</span>
                                <span className='transition group-open:rotate-180'>
                                    <ChevronDown className=' w-4 h-5' />
                                </span>
                            </summary>
                            {orderData?.order?.products?.length > 0 &&
                                <div className='cart h-[210px] pe-3 overflow-auto'>
                                    {orderData?.order?.products?.map((elem, index) => (
                                        <div className='cart-card gap-4 flex flex-wrap sm:flex-nowrap items-start mt-1'>
                                            <div className="cart-img">
                                                <img src={elem?.image || NO_PHOTO} alt={elem?.name} className='inline-block w-full max-h-full object-cover' />
                                            </div>
                                            <div className='w-full'>
                                                <div className='flex flex-wrap items-start w-full justify-between'>
                                                    <div className='flex w-full items-center justify-between flex-wrap'>
                                                        <div>
                                                            <span className='text-sm inline-block font-medium mb-1'>{`${elem?.name.substring(0, 20)}${elem?.product_name?.length > 20 ? '...' : ''}`}</span>
                                                            <div className='info-text text-sm items-center gap-4'>
                                                                {/* <p>Size : L</p> */}
                                                                {elem?.sku_id && <p>SKU ID : #{elem?.sku_id}</p>}
                                                                <p>Qty : {elem?.quantity}</p>
                                                                {elem?.is_return && <span className='text-sm inline-block font-medium mb-1'>Returned</span>}
                                                            </div>
                                                        </div>
                                                        <span className='text-base font-semibold mt-2'>{FormatAmount(elem?.selling_price, staffInfo?.client)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            }
                        </details>
                        <span className='text-[16px] block font-semibold'>Customer Informaction</span>
                        <div className='grid grid-cols-1 sm:grid-cols-2 gap-5'>
                            <div>
                                <span className='info-text block mb-1'>Name</span>
                                <span className='text-base font-medium text-black block'>{orderData?.order?.user?.name || '-'}</span>
                            </div>
                            <div>
                                <span className='info-text block mb-1'>Phone Number</span>
                                <span className='text-base font-medium text-black block'>{orderData?.order?.user?.phone || '-'}</span>
                            </div>
                            {orderData?.order?.user?.email && <div>
                                <span className='info-text block mb-1'>Mail</span>
                                <span className='text-base font-medium text-black block'>{orderData?.order?.user?.email || '-'}</span>
                            </div>}
                            {orderData?.order?.user?.expire_date && <div>
                                <span className='info-text block mb-1'>MemberShip Ex-Date</span>
                                <span className='text-base font-medium text-black block'>{formatDate(orderData?.order?.user?.expire_date, staffInfo?.client)}</span>
                            </div>}
                            {orderData?.order?.pos_membership?.product_name && <div>
                                <span className='info-text block mb-1'>MemberShip</span>
                                <span className='text-base font-medium text-black block'>{orderData?.order?.pos_membership?.product_name}</span>
                            </div>}
                        </div>
                        <hr />
                        <span className='text-[16px] block font-semibold'>Order Summary</span>
                        <div className='bg-secondary p-5 rounded-[10px]'>
                            <div className="space-y-1 5">
                                <div className='flex items-center justify-between'>
                                    <span className='info-text font-medium'>Items</span>
                                    <span className='font-semibold'>{orderData?.order?.products?.reduce((total, product) => total + product.quantity, 0)} Items</span>
                                </div>
                                <div className='flex items-center justify-between'>
                                    <span className='info-text font-medium'>Sub Total</span>
                                    <span className='font-semibold'>{FormatAmount(calculateTotalPrice(orderData?.order?.products), staffInfo?.client)}</span>
                                </div>
                                <div className='flex items-center justify-between'>
                                    <span className='info-text font-medium'>Membership  Discount</span>
                                    <span className='font-semibold'>0</span>
                                </div>
                                <div className='flex items-center error-text justify-between'>
                                    <span className='font-medium'>Tax</span>
                                    <span className='font-semibold'>{FormatAmount(orderData?.order?.tax_amount, staffInfo?.client)}</span>
                                </div>
                                <div className='flex items-center discount-text justify-between'>
                                    <span className='font-medium'>Discount Applied</span>
                                    <span className='font-semibold'>{FormatAmount(orderData?.order?.total_discount, staffInfo?.client)}</span>
                                </div>
                                <div className='flex items-center discount-text justify-between'>
                                    <span className='font-medium'>Adjust Discount</span>
                                    <span className='font-semibold'>{FormatAmount(orderData?.order?.adjust_discount, staffInfo?.client)}</span>
                                </div>
                            </div>
                            <hr className='border border-dashed my-3 border-color border-5' />
                            <div className='flex items-center justify-between'>
                                <span className='font-medium info-text'>TOTAL</span>
                                <span className='font-semibold'>{FormatAmount(orderData?.order?.total_price, staffInfo?.client)}</span>
                            </div>
                        </div>
                        {orderData?.order?.status === 'completed' && <div className='flex flex-wrap gap-4 items-center justify-around'>
                            <button type='button' className='secondary-btn flex items-center' onClick={downloadInvoice}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-4 me-1">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                </svg>
                                Download Invoice
                            </button>
                            <button type='button' className='secondary-btn flex items-center' onClick={() => setOpenShare(true)}>
                                <ShareIcon className='size-4 me-1' />
                                Share Invoice
                            </button>
                            {isRetunable?.length > 0 && <button type='button' className='secondary-btn flex items-center' onClick={() => setOpenRefund(true)}>
                                <InboxIcon className='size-4 me-1' />
                                Product Refund
                            </button>}
                        </div>}
                    </div> :
                    <div className='h-screen gap-4 info-text flex items-center justify-center w-full flex-col text-center'>
                        <svg
                            width={44}
                            height={44}
                            viewBox="0 0 44 44"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M42.8334 1.16663L1.16669 42.8333M42.8334 22C42.8334 33.5059 33.506 42.8333 22 42.8333C10.4941 42.8333 1.16669 33.5059 1.16669 22C1.16669 10.494 10.4941 1.16663 22 1.16663C33.506 1.16663 42.8334 10.494 42.8334 22Z"
                                stroke="currentcolor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <p>No Detail Found Please Select </p>
                    </div>
            }
            <Popup showPopup={openShare} closePopup={handleClosePopup} callComponant={<SocialShare orderData={orderData?.order} handleClosePopup={handleClosePopup} />} closebtn={true} />
            <Popup showPopup={openRefund} closePopup={handleCloseRefundPopup} callComponant={<RefundProduct orderData={orderData?.order} handleClosePopup={handleCloseRefundPopup} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} productInfo={productInfo} setProductInfo={setProductInfo} />} closebtn={true} />
        </>
    )
}

export default ViewOrder